let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fz6If")).then(() => parcelRequire('gSLfa'));